export type MypageMenuItem = {
  label: string;
  path: string;
  tab?: MypageProfileTab;
  match?: (pathname: string) => boolean;
};

export type MypageProfileTab = 'coin' | 'charge' | 'exchange';

const DESKTOP_MQ = '(min-width: 769px)';

function isPcViewport() {
  return typeof window !== 'undefined' && window.matchMedia(DESKTOP_MQ).matches;
}

export function readMypageProfileTab(): MypageProfileTab | null {
  if (typeof window === 'undefined') return null;
  const tab = new URLSearchParams(window.location.search).get('tab')?.trim();
  if (tab === 'coin' || tab === 'charge' || tab === 'exchange') return tab;
  return null;
}

export function buildMypageProfilePath(tab?: MypageProfileTab | null): string {
  if (!tab) return '/mypage/profile';
  return `/mypage/profile?tab=${tab}`;
}

/** twolivetv.com pg_id=mypage sidebar menu – 내역은 /mypage/profile 탭으로 통합 */
export const MYPAGE_MENU_ITEMS: MypageMenuItem[] = [
  {
    label: '코인내역',
    path: buildMypageProfilePath('coin'),
    tab: 'coin',
    match: (pathname) => {
      if (!isMypageHub(pathname)) return false;
      const tab = readMypageProfileTab();
      if (tab === 'coin') return true;
      return !tab && isPcViewport();
    },
  },
  {
    label: '충전내역',
    path: buildMypageProfilePath('charge'),
    tab: 'charge',
    match: (pathname) => isMypageHub(pathname) && readMypageProfileTab() === 'charge',
  },
  {
    label: '환전내역',
    path: buildMypageProfilePath('exchange'),
    tab: 'exchange',
    match: (pathname) => isMypageHub(pathname) && readMypageProfileTab() === 'exchange',
  },
  {
    label: '코인환전',
    path: '/exchange-request',
    match: (pathname) => pathname.startsWith('/exchange-request'),
  },
  {
    label: '회원정보수정',
    path: '/mypage/profile/edit',
    match: (pathname) => pathname.startsWith('/mypage/profile/edit'),
  },
];

export function isMypageMenuActive(item: MypageMenuItem, pathname: string): boolean {
  if (item.match) return item.match(pathname);
  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}

export function isMypageHub(pathname: string): boolean {
  return pathname === '/mypage' || pathname === '/mypage/profile';
}

/** 관리 헤더 + 하단 콘텐츠를 함께 표시하는 마이페이지 섹션 경로 */
export function isMypageSectionPath(pathname: string): boolean {
  return isMypageHub(pathname)
    || pathname.startsWith('/exchange-request')
    || pathname.startsWith('/mypage/profile/edit');
}

export function resolveMypageProfileTab(pathname: string): MypageProfileTab | null {
  if (!isMypageHub(pathname)) return null;
  const tab = readMypageProfileTab();
  if (tab) return tab;
  return isPcViewport() ? 'coin' : null;
}

/** @deprecated use resolveMypageProfileTab */
export const MYPAGE_HISTORY_MENU_ITEMS = MYPAGE_MENU_ITEMS.slice(0, 3);

/** @deprecated */
export const MYPAGE_OTHER_MENU_ITEMS = MYPAGE_MENU_ITEMS.slice(3);

/** @deprecated */
export function isMypageHistoryPath(pathname: string): boolean {
  return resolveMypageProfileTab(pathname) != null;
}
